import React, { useState } from 'react';
import { changePassword } from '../services/authService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';
import './ChangePassword.css';
import { useTranslation } from 'react-i18next';

const ChangePassword = () => {
  const { t } = useTranslation('login');

  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!passwords.currentPassword) {
      showErrorToast(t('CURRENTPASSWORDISREQUIRED'));
      return false;
    }

    if (!passwords.newPassword) {
      showErrorToast(t('NEWPASSWORDISREQUIRED'));
      return false;
    } else if (passwords.newPassword.length < 8) {
      showErrorToast(t('PASSWORDMUSTBEATLEAST8CHARACTERS'));
      return false;
    }

    if (!passwords.confirmPassword) {
      showErrorToast(t('PLEASECONFIRMYOURNEWPASSWORD'));
      return false;
    } else if (passwords.newPassword !== passwords.confirmPassword) {
      showErrorToast(t('PASSWORDSDONOTMATCH'));
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setIsLoading(true);

      // Prepare data for API
      const apiData = {
        current_password: passwords.currentPassword,
        new_password: passwords.newPassword,
        new_password_confirmation: passwords.confirmPassword,
      };

      const response = await changePassword(apiData);

      if (response?.success) {
        showSuccessToast(response.message);
        // Reset form after successful submission
        setPasswords({
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
      }
    } catch (error) {
      showErrorToast(error.message || 'Something went wrong');
      console.error('Error updating password:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = (field) => {
    switch (field) {
      case 'current':
        setShowCurrentPassword(!showCurrentPassword);
        break;
      case 'new':
        setShowNewPassword(!showNewPassword);
        break;
      case 'confirm':
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  return (
    <div className="change-password">
      <form onSubmit={handleSubmit}>
        <div className="password-field">
          <div className="row change-password pt-0 px-3">
            <div className="col-md-8 px-0">
              <h4 className="mb-4">{t('CHANGEPASSWORD')}</h4>

              <div className="col-sm-6">
                <div className="did-floating-label-content mb-4">
                  <input
                    className="did-floating-input"
                    type={showCurrentPassword ? 'text' : 'password'}
                    name="currentPassword"
                    id="currentPassword"
                    onChange={handleChange}
                    placeholder=" "
                    value={passwords.currentPassword}
                    required
                  />
                  <label className="did-floating-label">
                    {t('CURRENTPASSWORD')}
                  </label>
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => togglePasswordVisibility('current')}
                  >
                    <img
                      src={
                        showCurrentPassword
                          ? 'images/eye-black-open.svg'
                          : 'images/eye-black-close.svg'
                      }
                      alt={
                        showCurrentPassword ? 'Show password' : 'Hide password'
                      }
                    />
                  </button>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="did-floating-label-content">
                  <input
                    type={showNewPassword ? 'text' : 'password'}
                    id="newPassword"
                    name="newPassword"
                    value={passwords.newPassword}
                    onChange={handleChange}
                    placeholder=" "
                    className="did-floating-input"
                  />
                  <label className="did-floating-label">
                    {t('NEWPASSWORD')}
                  </label>
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => togglePasswordVisibility('new')}
                  >
                    <img
                      src={
                        showNewPassword
                          ? 'images/eye-black-open.svg'
                          : 'images/eye-black-close.svg'
                      }
                      alt={showNewPassword ? 'Show password' : 'Hide password'}
                    />
                  </button>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="did-floating-label-content">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={passwords.confirmPassword}
                    onChange={handleChange}
                    placeholder=" "
                    className="did-floating-input"
                  />
                  <label className="did-floating-label">
                    {t('CONFIRMNEWPASSWORD')}
                  </label>
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => togglePasswordVisibility('confirm')}
                  >
                    <img
                      src={
                        showConfirmPassword
                          ? 'images/eye-black-open.svg'
                          : 'images/eye-black-close.svg'
                      }
                      alt={
                        showConfirmPassword ? 'Show password' : 'Hide password'
                      }
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" className="save" disabled={isLoading}>
          {isLoading ? t('UPDATING') + '...' : t('UPDATEPASSWORD')}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
